module.exports = __webpack_public_path__ + "static/media/icono3dGrisCruz.ef59fd42.svg";